import { render, staticRenderFns } from "./InvoiceStateBadge.vue?vue&type=template&id=d96b03a6&scoped=true&"
import script from "./InvoiceStateBadge.vue?vue&type=script&lang=js&"
export * from "./InvoiceStateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96b03a6",
  null
  
)

export default component.exports